import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { HttpService } from '../../http.service';
import { environment } from '../../../environments/environment';
import { Postcode } from '../../models/postcode';
import { URLSearchParams } from '@angular/http';
import { Paginated } from '../../models/paginated';
import { Observable } from 'rxjs/Observable';
import { Sort } from '../../models/sort';

@Injectable()
export class PostcodesService extends BaseService
{
	private http: HttpService;
	private api: string;

	constructor(http: HttpService)
	{
		super();

		this.http = http;
		this.api = environment.api_url;
	}

	public searchPostcodes(params: URLSearchParams): Promise<Paginated<Postcode[]>>
	{
		return this.http
			.get(this.api + 'postcodes', {search: params})
			.toPromise()
			.then(response => response.json() as Paginated<Postcode[]>)
			.catch(this.handleError);
	}

	public getPreferredPostcodes(page: number, filters?, sorting?: Sort): Observable<Paginated<Postcode[]>>
	{
		const params = [];
		params.push('page=' + page);

		if (typeof filters !== 'undefined' && filters !== null) {
			if (filters.postcode && filters.postcode.value) {
				params.push('postcode=' + filters.postcode.value);
			}

			if (filters.description && filters.description.value) {
				params.push('description=' + filters.description.value);
			}

			if (filters.city && filters.city.value) {
				params.push('city=' + filters.city.value);
			}

			if (filters['preferred_distributor.name'] && filters['preferred_distributor.name'].value) {
				params.push('preferred_distributor=' + filters['preferred_distributor.name'].value);
			}
		}

		if (typeof sorting !== 'undefined' && sorting !== null) {
			params.push('order=' + sorting.field + ',' + sorting.direction);
		}

		return this.http.get(this.api + 'postcodes/has/area_postcode?' + params.join('&'))
			.map(response => response.json() as Paginated<Postcode[]>);
	}

	public postcodesCanHavePreferredDistributor(): Promise<Postcode[]>
	{
		return this.http
			.get(this.api + 'postcodes/has/area_postcode')
			.toPromise()
			.then(response => response.json().data as Postcode[])
			.catch(this.handleError);
	}

	public getPostcodeById(param: number)
	{
		return this.http
			.get(this.api + 'postcodes/' + param)
			.toPromise()
			.then(response => response.json().data as Postcode)
			.catch(this.handleError);
	}

	public attachPreferredDistributor(postcode: Postcode): Promise<Postcode>
	{
		return this.http
			.post(this.api + 'postcodes/' + postcode.id + '/attach/preferredDistributor', JSON.stringify(postcode))
			.toPromise()
			.then(response => response.json().data as Postcode)
			.catch(this.handleError);
	}

	public getOpenPostcodes()
	{
		return this.http
			.get(this.api + 'postcodes/without/distributors')
			.toPromise()
			.then(response => response.json().data as Postcode[])
			.catch(this.handleError);
	}
}



// WEBPACK FOOTER //
// ./src/app/postcodes/services/postcodes.service.ts